<template>
    <div>
        <b-tabs v-model="tabIndex" v-if="productSelectedToAssing">
            <b-tab title="Ubicaciones">
                <Ubicaciones :IdProducto.sync="productSelectedToAssing.id" :show_companies="0" v-if="tabIndex === 0 && productSelectedToAssing"></Ubicaciones>
            </b-tab>
            <b-tab title="Campos Personaliz.">
                <CamposPersonalizados :IdProducto.sync="productSelectedToAssing.id" :show_companies="0" v-if="tabIndex === 1 && productSelectedToAssing"></CamposPersonalizados>
            </b-tab>
            <b-tab title="Ubicaciones Cantidad">
                <UbicacionesCantidad :IdProducto.sync="productSelectedToAssing.id" :show_companies="0" v-if="tabIndex === 2 && productSelectedToAssing"></UbicacionesCantidad>
            </b-tab>
        </b-tabs>
        <SearchProduct v-if="!productSelectedToAssing"></SearchProduct>
    </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import SearchProduct from './SearchProduct.vue'
import Ubicaciones from './Ubicaciones'
import CamposPersonalizados from './CamposPersonalizados.vue'
import UbicacionesCantidad from './UbicacionesCantidad.vue'

export default {
    name:'SearchAndAssignProducts',
    data: function(){
        return{
            tabIndex: 0,
        };
    },
    watch:{
        tabIndex(newValue) {
            switch (newValue) {
                case 0:
                    // this.traeAsignacion();
                    break;
                case 1:
                    break;
                case 2:
                    break;
                default:
                    break;
            }
        }
    },
    unmounted(){
        this.setSelectedProduct(null);
    },
    components:{
        Ubicaciones,
        SearchProduct,
        CamposPersonalizados,
        UbicacionesCantidad,
    },
    methods:{
        async traeAsignacion(){
            await this.getInfoAsignacion(this.productSelectedToAssing.id);
        },
        async traeBasesAreas(){
            await this.getEmpresasAsig(this.productSelectedToAssing.id);
        },
        async traeCamposPersonalizados(){
          await this.getCamposPersonalizados(this.productSelectedToAssing.id);
        },
        ...mapActions('asignacionproductos',[
            'getInfoAsignacion',
            'getEmpresasAsig',
            'getCamposPersonalizados',
            'setSelectedProduct'
        ])
    },
    computed: {
    ...mapState('asignacionproductos', ['productSelectedToAssing']),
  },
}
</script>
